import httpStore from "@/api/httpStore.js";

/**
 * Fetch all saved price lists from the DB.
 * @returns {Promise<Array>} Array of price list objects { id, make, url, updatedAt, createdBy }
 */
export function getPriceLists() {
  return httpStore.get("/price_lists").then(res => res.data);
}

/**
 * Trigger generation of Polimotor price lists for every vehicle make.
 * @returns {Promise<Object>} Summary { total, success, errors, details[] }
 */
export function generatePriceLists() {
  return httpStore.post("/price_lists/generate").then(res => res.data);
}

/**
 * Trigger generation of a Polimotor price list for a single vehicle make.
 * @param {string} make
 * @returns {Promise<Object>} Summary { total, success, errors, details[] }
 */
export function generatePriceListForMake(make) {
  return httpStore
    .post("/price_lists/generate", { make })
    .then(res => res.data);
}
